require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/es7.symbol.observable.js
// module id = vbpo
// module chunks = 0